import { BaseService } from './BaseService';
import { API_ENDPOINTS } from './config';

interface HealthResponse {
  status: string;
  version: string;
  message: string;
}

export class HealthService extends BaseService {
  static async checkHealth(): Promise<boolean> {
    try {
      const response = await this.get<HealthResponse>(API_ENDPOINTS.HEALTH);
      console.log('[HealthService] Health check response:', response);
      // If we get a response, consider the API healthy
      return true;
    } catch (error) {
      console.error('API health check failed:', error);
      return false;
    }
  }

  static getErrorMessage(): string {
    return 'Unable to connect to the API server. Please check if the server is running and try again.';
  }
}
